import { FC, useEffect, useState } from 'react';
import { Box, IconButton, Link, Tooltip, Typography } from '@mui/material';
import { ContentCopy } from '@mui/icons-material';
import { NoticeDialog } from 'ui/NoticeDialog';
import { getLastMileTrackingLink } from 'components/EuDdp/eu-ddp-structure';
import { COLORS } from 'services/constants/colors';

type TLastMileTrackingDialogProps = {
	open: boolean;
	setClose: () => void;
	lastMileTrackingNumber: string | null;
};

export const LastMileTrackingDialog: FC<TLastMileTrackingDialogProps> = ({
	open,
	setClose,
	lastMileTrackingNumber,
}) => {
	const [isCopied, setIsCopied] = useState(false);
	const link = getLastMileTrackingLink(lastMileTrackingNumber);

	useEffect(() => {
		if (!open) setIsCopied(false);
	}, [open]);

	const handleCopy = () => {
		navigator.clipboard
			.writeText(link)
			.then(() => {
				setIsCopied(true);
				setTimeout(() => setIsCopied(false), 2000);
			})
			.catch(() => {
				// copy failed
			});
	};

	return (
		<NoticeDialog open={open} setClose={setClose} title="Last Mile Tracking Information">
			<Typography variant="body2" color="GrayText" gutterBottom>
				Last Mile Tracking Link:
			</Typography>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'center',
					gap: 1,
				}}
			>
				<Typography
					variant="body2"
					sx={{ wordBreak: 'break-all', color: COLORS.PRIMARY, fontWeight: 550 }}
				>
					{link}
				</Typography>
				<Tooltip title={isCopied ? 'Copied' : 'Copy to clipboard'} arrow>
					<IconButton onClick={handleCopy} size="small">
						<ContentCopy
							sx={{ fontSize: '1rem', color: isCopied ? 'success.main' : 'primary.main' }}
						/>
					</IconButton>
				</Tooltip>
			</Box>
		</NoticeDialog>
	);
};
